import { SurveyQuestion } from '../types';

// Survey questions based on provided format
export const surveyQuestions: SurveyQuestion[] = [
  // Basic Information
  {
    id: 'name',
    text: "What's your name?",
    type: 'text',
    category: 'Basic Info',
    required: true,
  },
  {
    id: 'updated_from_last_year',
    text: 'Have you updated your survey answers from last year?',
    type: 'radio',
    category: 'Basic Info',
    required: false,
    options: ['Yes', 'No', 'First time participating'],
  },
  {
    id: 'address',
    text: "What's your address?",
    type: 'textarea',
    category: 'Basic Info',
    required: true,
  },
  {
    id: 'phone',
    text: 'What phone do you have? (e.g., iPhone 12, Samsung Galaxy S10)',
    type: 'text',
    category: 'Basic Info',
    required: false,
  },

  // Gift Preferences
  {
    id: 'specific_request',
    text: 'Do you want anything specific from your secret santa?',
    type: 'textarea',
    category: 'Gift Preferences',
    required: false,
  },
  {
    id: 'favorite_stores',
    text: 'What are your favorite stores to shop at?',
    type: 'textarea',
    category: 'Gift Preferences',
    required: false,
  },
  {
    id: 'collections',
    text: 'Do you collect anything or are you a fan of a particular object?',
    type: 'textarea',
    category: 'Gift Preferences',
    required: false,
  },

  // Food & Dietary
  {
    id: 'favorite_foods',
    text: 'What are your favorite foods?',
    type: 'textarea',
    category: 'Food & Dietary',
    required: false,
  },
  {
    id: 'favorite_candy',
    text: 'What are your favorite types of candy?',
    type: 'textarea',
    category: 'Food & Dietary',
    required: false,
  },
  {
    id: 'white_chocolate',
    text: 'Do you like white chocolate?',
    type: 'radio',
    category: 'Food & Dietary',
    required: false,
    options: ['Yes', 'No'],
  },
  {
    id: 'milk_chocolate',
    text: 'Do you like milk chocolate?',
    type: 'radio',
    category: 'Food & Dietary',
    required: false,
    options: ['Yes', 'No'],
  },
  {
    id: 'dark_chocolate',
    text: 'Do you like dark chocolate?',
    type: 'radio',
    category: 'Food & Dietary',
    required: false,
    options: ['Yes', 'No'],
  },
  {
    id: 'dietary_restrictions',
    text: 'Any dietary restrictions?',
    type: 'textarea',
    category: 'Food & Dietary',
    required: false,
  },
  {
    id: 'favorite_drinks',
    text: 'What do you like to drink?',
    type: 'textarea',
    category: 'Food & Dietary',
    required: false,
  },
  {
    id: 'favorite_restaurants',
    text: 'What are your favorite restaurants?',
    type: 'textarea',
    category: 'Food & Dietary',
    required: false,
  },
  {
    id: 'meal_preference',
    text: 'Breakfast, Lunch, or Dinner?',
    type: 'checkbox',
    category: 'Food & Dietary',
    required: false,
    options: ['Breakfast', 'Lunch', 'Dinner'],
  },
  {
    id: 'hot_beverage',
    text: 'Coffee, Tea, or Hot Chocolate?',
    type: 'checkbox',
    category: 'Food & Dietary',
    required: false,
    options: ['Coffee', 'Tea', 'Hot Chocolate', 'Other'],
  },

  // Personal Interests
  {
    id: 'favorite_scent',
    text: "What's your favorite scent?",
    type: 'textarea',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'hobbies',
    text: 'Do you have any hobbies or what do you like to do in your free time?',
    type: 'textarea',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'favorite_books',
    text: "Who's your favorite author or what's your favorite book/movie genre?",
    type: 'textarea',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'favorite_animal',
    text: "What's your favorite animal?",
    type: 'text',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'favorite_color',
    text: "What's your favorite color(s)?",
    type: 'text',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'favorite_music',
    text: "What's your favorite music genre or who's your favorite artist?",
    type: 'textarea',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'favorite_season',
    text: "What's your favorite time of year?",
    type: 'select',
    category: 'Personal Interests',
    required: false,
    options: ['Spring', 'Summer', 'Fall', 'Winter'],
  },
  {
    id: 'travel_destination',
    text: "What's one place you'd like to visit?",
    type: 'text',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'favorite_shows',
    text: "What's your favorite movie or TV show?",
    type: 'textarea',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'favorite_time_of_day',
    text: "What's your favorite part of the day?",
    type: 'select',
    category: 'Personal Interests',
    required: false,
    options: ['Early morning', 'Morning', 'Afternoon', 'Evening', 'Late night'],
  },
  {
    id: 'favorite_websites',
    text: 'What are your favorite website(s)?',
    type: 'textarea',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'home_activity',
    text: "What's your go-to at home activity?",
    type: 'textarea',
    category: 'Personal Interests',
    required: false,
  },
  {
    id: 'deserted_island',
    text: 'Three things you would bring to a deserted island?',
    type: 'textarea',
    category: 'Personal Interests',
    required: false,
  },

  // Sizing Information
  {
    id: 'shoe_size',
    text: "What's your shoe size?",
    type: 'text',
    category: 'Sizing',
    required: false,
  },
  {
    id: 'pant_size',
    text: "What's your pant size?",
    type: 'text',
    category: 'Sizing',
    required: false,
  },
  {
    id: 'shirt_size',
    text: "What's your shirt size?",
    type: 'text',
    category: 'Sizing',
    required: false,
  },
  {
    id: 'dress_size',
    text: 'If you wear dresses, what\'s your dress size?',
    type: 'text',
    category: 'Sizing',
    required: false,
  },

  // Additional Notes
  {
    id: 'additional_notes',
    text: 'Anything else your Secret Santa should know?',
    type: 'textarea',
    category: 'Additional Info',
    required: false,
  },
];

export const getSurveyQuestionsByCategory = () => {
  const categories: Record<string, SurveyQuestion[]> = {};
  
  surveyQuestions.forEach((question) => {
    if (!categories[question.category]) {
      categories[question.category] = [];
    }
    categories[question.category].push(question);
  });
  
  return categories;
};

export const getCategoryNames = (): string[] => {
  return Array.from(new Set(surveyQuestions.map(q => q.category)));
};

